<template>
	<div class="Nav_box">
		<div class="nav_logo_box" @click="navbanner('/')"></div>
		<div class="nav_slogan_box" @click="navbanner('/')">让产业更智能</div>
		<div class="nav_tabber_box">
			<div class="nav_tabber_text_box">
				<!-- <div class="More_options_box">
          <div @click="homePageFun(1)"
               :style="currentPage == 1?'background: #ff6100;':''"
               class="More_options_li_box">我们的优势</div>
          <div @click="homePageFun(2)"
               :style="currentPage == 2?'background: #ff6100;':''"
               class="More_options_li_box">我们的服务</div>
          <div @click="homePageFun(3)"
               :style="currentPage == 3?'background: #ff6100;':''"
               class="More_options_li_box">我们能做什么</div>
          <div @click="homePageFun(4)"
               :style="currentPage == 4?'background: #ff6100;':''"
               class="More_options_li_box">开发服务流程</div>
          <div @click="homePageFun(5)"
               :style="currentPage == 5?'background: #ff6100;':''"
               class="More_options_li_box">精品案例展示</div>
          <div @click="homePageFun(6)"
               :style="currentPage == 6?'background: #ff6100;':''"
               class="More_options_li_box">新闻资讯展示</div>
          <div @click="homePageFun(7)"
               :style="currentPage == 7?'background: #ff6100;':''"
               class="More_options_li_box">合作伙伴</div>
          <div @click="homePageFun(8)"
               :style="currentPage == 8?'background: #ff6100;':''"
               class="More_options_li_box">联系我们</div>
        </div> -->
				<div class="text_box" :style="path == '/'? 'color:#ff6100;font-weight: 700;':''"
					@click="navbanner('/')">
					首页
					<div :style="path == '/'? 'bottom: 0.15rem;':'' " class="text_boxbefore"></div>
				</div>
			</div>
			<div class="nav_tabber_text_box">
				<div class="text_box" :style="path == '/Ai'? 'color:#ff6100;font-weight: 700;':''"
					@click="navbanner('/Ai')">
					AI解决方案
					<div :style="path == '/Ai'? 'bottom: 0.15rem;':'' " class="text_boxbefore"></div>
				</div>
			</div>
			<div class="nav_tabber_text_box">
				<div class="More_options_box">
					<div @click="programmePageFun(1)" :style="programmePage == 1?'background: #ff6100;':''"
						class="More_options_li_box">我们解决的难题</div>
					<div @click="programmePageFun(2)" :style="programmePage == 2?'background: #ff6100;':''"
						class="More_options_li_box">行业解决方案</div>
				</div>
				<div class="text_box" :style="path == '/programme'? 'color:#ff6100;font-weight: 700;':''"
					@click="navbanner('/programme')">
					软件解决方案
					<div :style="path == '/programme'? 'bottom: 0.15rem;':'' " class="text_boxbefore"></div>
				</div>
			</div>
			<div class="nav_tabber_text_box">
				<div class="More_options_box">
					<div v-for="item,index in productList" :key="index+'1'">
						<div @click="presentationPageFun(item.productId)"
							:style="presentationPage == item.productId?'background: #ff6100;':''"
							class="More_options_li_box">{{item.productTitle}}</div>
					</div>
				</div>
				<div @click="navbanner('/presentation')"
					:style="path == '/presentation'? 'color:#ff6100;font-weight: 700;':''" class="text_box">
					案例展示
					<div :style="path == '/presentation'? 'bottom: 0.15rem;':'' " class="text_boxbefore"></div>
				</div>
			</div>
			<div class="nav_tabber_text_box">
				<div class="More_options_box">
					<div v-for="item,index in dataList" :key="index+'1'">
						<div @click="JournalismPageFun(index+1)"
							:style="JournalismPage == index+1?'background: #ff6100;':''" class="More_options_li_box">
							{{item.dictLabel}}
						</div>
					</div>
				</div>
				<div @click="navbanner('/Journalism')"
					:style="path == '/Journalism'? 'color:#ff6100;font-weight: 700;':''" class="text_box">
					新闻资讯
					<div :style="path == '/Journalism'? 'bottom: 0.15rem;':'' " class="text_boxbefore"></div>
				</div>
			</div>
			<div class="nav_tabber_text_box">
				<div class="More_options_box">
					<div @click="AboutUSPageFun(1)" :style="AboutUSPage == 1?'background: #ff6100;':''"
						class="More_options_li_box">企业概况</div>
					<div @click="AboutUSPageFun(2)" :style="AboutUSPage == 2?'background: #ff6100;':''"
						class="More_options_li_box">公司风采</div>
					<div @click="AboutUSPageFun(3)" :style="AboutUSPage == 3?'background: #ff6100;':''"
						class="More_options_li_box">资质荣誉</div>
					<div @click="AboutUSPageFun(4)" :style="AboutUSPage == 4?'background: #ff6100;':''"
						class="More_options_li_box">合作伙伴</div>
					<div @click="AboutUSPageFun(5)" :style="about == 1?'background: #ff6100;':''"
						class="More_options_li_box">合作流程</div>
					<div @click="AboutUSPageFun(6)" :style="about == 2?'background: #ff6100;':''"
						class="More_options_li_box">加入我们</div>
				</div>
				<div @click="navbanner('/AboutUS')" :style="path == '/AboutUS'? 'color:#ff6100;font-weight: 700;':''"
					class="text_box">
					关于我们
					<div :style="path == '/AboutUS'? 'bottom: 0.15rem;':'' " class="text_boxbefore"></div>
				</div>
			</div>
			<div class="nav_tabber_text_box">
				<div class="More_options_box">
					<div @click="servicePageFun(1)" :style="servicePage == 1?'background: #ff6100;':''"
						class="More_options_li_box">服务类型</div>
					<div @click="servicePageFun(2)" :style="servicePage == 2?'background: #ff6100;':''"
						class="More_options_li_box">开发服务流程</div>
					<div @click="servicePageFun(3)" :style="servicePage == 3?'background: #ff6100;':''"
						class="More_options_li_box">服务保障</div>
					<div @click="servicePageFun(4)" :style="servicePage == 4?'background: #ff6100;':''"
						class="More_options_li_box">我们的优势</div>
					<div @click="servicePageFun(5)" :style="servicePage == 5?'background: #ff6100;':''"
						class="More_options_li_box">在线提交信息</div>
				</div>
				<div @click="navbanner('/service')" :style="path == '/service'? 'color:#ff6100;font-weight: 700;':''"
					class="text_box">
					服务
					<div :style="path == '/service'? 'bottom: 0.15rem;':'' " class="text_boxbefore"></div>
				</div>
			</div>
		</div>
		<div class="nav_tel_box">
			<div class="nav_tel_img_box"></div>
			<div class="nav_tel_text_box">18037190102</div>
			<div class="nav_code_img_box">
				<div class="nav_code_img"></div>
			</div>
		</div>
		<div class="consulting_box">
			<div class="consulting_li_box">
				<i class="iconfont icon-weixin"></i>
				<span>微信咨询</span>
				<div class="consulting_tips_box"></div>
			</div>
			<div class="consulting_li_box">
				<i class="iconfont icon-gonggong-dianhua"></i>
				<span>电话咨询</span>
				<div class="consulting_tips_tel_box">18037190102</div>
			</div>
			<div class="consulting_li_box">
				<i class="iconfont icon-kefu"></i>
				<span>在线咨询</span>
			</div>
		</div>
	</div>
</template>

<script>
	// 导入mapState方法，同时导入其他方法的，方便等下使用
	import {
		mapMutations
	} from 'vuex';
	import {
		listProduct
	} from "@/api/product";
	import {
		listData
	} from "@/api/dict/data";
	export default {
		name: "Nav",
		computed: {
			currentPage: {
				get() {
					return this.$store.state.currentPage
				},
				set(value) {
					this.$store.commit('putcurrentPage', value)
				}
			},
			programmePage: {
				get() {
					return this.$store.state.programmePage
				},
				set(value) {
					this.$store.commit('putprogrammePage', value)
				}
			},
			presentationPage: {
				get() {
					return this.$store.state.presentationPage
				},
				set(value) {
					this.$store.commit('putpresentationPage', value)
				}
			},
			JournalismPage: {
				get() {
					return this.$store.state.JournalismPage
				},
				set(value) {
					this.$store.commit('putJournalismPage', value)
				}
			},

			AboutUSPage: {
				get() {
					return this.$store.state.AboutUSPage
				},
				set(value) {
					this.$store.commit('putAboutUSPage', value)
				}
			},
			servicePage: {
				get() {
					return this.$store.state.servicePage
				},
				set(value) {
					this.$store.commit('putservicePage', value)
				}
			}
		},
		data() {
			return {
				path: '/',
				NavList: [],
				about: 0,
				// 产品管理表格数据
				productList: [],
				dataList: []
			};
		},
		watch: {
			$route(to, from) {
				this.chengeRoute()
			}
		},
		created() {
			this.$nextTick(() => {
				this.chengeRoute()
			});
			this.getProductList();
			this.getDictList();
		},
		methods: {
			getDictList() {
				listData({
					dictType: 'news_type'
				}).then(response => {
					this.dataList = response.rows;
				});
			},
			getProductList() {
				listProduct({}).then(response => {
					this.productList = response.rows;
				});
			},
			// 展开vuex总的方法
			...mapMutations(['putcurrentPage', 'putprogrammePage', 'putpresentationPage', 'putJournalismPage', ,
				'putAboutUSPage', 'putservicePage'
			]),
			// 点击首页下面的子菜单执行
			homePageFun(row) {
				if (this.$route.path == '/') {
					this.currentPage = row
					this.putcurrentPage(row)
				} else {
					this.currentPage = row
					this.$router.push('/')
					this.putcurrentPage(row)
				}
			},
			programmePageFun(row) {
				if (this.$route.path == '/programme') {
					this.programmePage = row
					this.putprogrammePage(row)
				} else {
					this.programmePage = row
					this.$router.push('/programme')
					this.putprogrammePage(row)
				}
			},
			presentationPageFun(row) {
				if (this.$route.path == '/presentation') {
					this.presentationPage = row
					this.putpresentationPage(row)
				} else {
					this.presentationPage = row
					this.$router.push('/presentation')
					this.putpresentationPage(row)
				}
			},
			JournalismPageFun(row) {
				if (this.$route.path == '/Journalism') {
					this.JournalismPage = row
					this.putJournalismPage(row)
				} else {
					this.JournalismPage = row
					this.putJournalismPage(row)
					this.$router.push('/Journalism')

				}
			},
			AboutUSPageFun(row) {
				if (row == 5) {
					this.$router.push('/AboutUS/cooperation')
					this.AboutUSPage = 1
					this.putAboutUSPage(1)
					this.about = 1
					return
				}
				if (row == 6) {
					this.$router.push('/AboutUS/recruit')
					this.AboutUSPage = 1
					this.putAboutUSPage(1)
					this.about = 2
					return
				}
				if (this.$route.path == '/AboutUS') {
					this.AboutUSPage = row
					this.putAboutUSPage(row)
				} else {
					this.AboutUSPage = row
					this.$router.push('/AboutUS')
					this.putAboutUSPage(row)
				}
				this.about = 0
			},
			servicePageFun(row) {
				if (this.$route.path == '/service') {
					this.servicePage = row
					this.putservicePage(row)
				} else {
					this.servicePage = row
					this.$router.push('/service')
					this.putservicePage(row)
				}
			},
			// 路由发生变化执行
			chengeRoute() {
				if (this.$route.path == '/' || this.$route.path.search('homePage') != -1) {
					this.path = '/'
					this.putcurrentPage(0)
				} else {
					this.putcurrentPage(0)
				}
				if (this.$route.path == '/Ai') {
					this.path = '/Ai'
				}
				if (this.$route.path == '/programme') {
					this.path = '/programme'
					this.putprogrammePage(0)
				} else {
					this.putprogrammePage(0)
				}

				if (this.$route.path == '/presentation' || this.$route.path.search('presentation') != -1) {
					this.path = '/presentation'
					this.putpresentationPage(0)
				} else {
					this.putpresentationPage(0)
				}
				if (this.$route.path == '/Journalism') {
					this.path = '/Journalism'
					this.putJournalismPage(0)
				} else {
					this.putJournalismPage(0)
				}
				if (this.$route.path == '/service') {
					this.path = '/service'
					this.putservicePage(0)
				} else {
					this.putservicePage(0)
				}
				if (this.$route.path == '/AboutUS' || this.$route.path.search('AboutUS') != -1) {
					this.path = '/AboutUS'
					this.putAboutUSPage(0)
				} else {
					this.putAboutUSPage(0)
				}
			},
			navbanner(row) {
				if (row == this.$route.path) {
					this.chengeRoute()
				}
				this.$router.push(row)
			}
		},
	};
</script>


<style scoped lang="scss">
	.Nav_box {
		position: fixed;
		top: 0rpx;
		left: 0rpx;
		width: 10rem;
		height: 0.5rem;
		background: #ffffff80;
		border-radius: 0px;
		display: flex;
		z-index: 9;

		.nav_logo_box {
			width: 0.75rem;
			height: 0.2083rem;
			margin-left: 0.2604rem;
			background-image: url("../static/images/img/homelogo.png");
			background-size: 100% 100%;
			margin-top: 0.1458rem;
		}

		.nav_slogan_box {
			display: inline-block;
			height: 0.1354rem;
			font-size: 0.0625rem;
			font-family: MicrosoftYaHei;
			line-height: 0.1354rem;
			color: #ff6100;
			letter-spacing: 0.0104rem;
			opacity: 1;
			margin-top: 0.171rem;
			padding-left: 0.0521rem;
			margin-left: 0.0521rem;
			border-left: 0.0104rem solid #ff6100;
		}

		.nav_tabber_box {
			display: inline-block;
			// margin-left: 1.6042rem;
			margin-left: 0.6042rem;
			font-size: 0.0833rem;
			font-family: MicrosoftYaHei;
			line-height: 0.5rem;
			color: #333333;
			opacity: 1;

			.nav_tabber_text_box {
				position: relative;
				display: inline-block;
				margin-right: 0.4167rem;
				transition: 0.3s;
				cursor: pointer;

				.More_options_box {
					position: absolute;
					left: -0.49rem;
					top: 0.5rem;
					width: 1.135rem;
					background: #00000050;
					transition: 0.3s;
					height: 0px;
					text-align: center;
					overflow: hidden;
					line-height: 0.2344rem;
					color: #fff;
					font-weight: 400;
					font-size: 0.0938rem;
				}

				.More_options_li_box {
					transition: 0.3s;
				}

				.More_options_li_box:hover {
					background: #ff6100;
				}

				.text_box {
					position: relative;
					overflow: hidden;
					color: #000;

					.text_boxbefore {
						position: absolute;
						bottom: -0.15rem;
						left: 0;
						display: inline-block;
						width: 100%;
						height: 0.0156rem;
						background: #ff6100;
						opacity: 1;
						border-radius: 0.0104rem;
						transition: 0.3s;
					}
				}
			}

			.nav_tabber_text_box:nth-child(2) {
				.More_options_box {
					left: -0.4rem;
				}
			}

			.nav_tabber_text_box:nth-child(3) {
				.More_options_box {
					left: -0.3rem;
				}
			}

			.nav_tabber_text_box:nth-child(4) {
				.More_options_box {
					left: -0.4rem;
				}
			}

			.nav_tabber_text_box:nth-child(5) {
				.More_options_box {
					left: -0.4rem;
				}
			}

			.nav_tabber_text_box:nth-child(6) {
				.More_options_box {
					left: -0.4rem;
				}
			}

			.nav_tabber_text_box:nth-child(1):hover {
				.More_options_box {
					height: 1.87rem;
				}
			}

			.nav_tabber_text_box:nth-child(2):hover {
				.More_options_box {
					height: 0.47rem;
				}
			}

			.nav_tabber_text_box:nth-child(3):hover {
				.More_options_box {
					height: 0.47rem;
				}
			}

			.nav_tabber_text_box:nth-child(4):hover {
				.More_options_box {
					height: 0.7rem;
				}
			}

			.nav_tabber_text_box:nth-child(5):hover {
				.More_options_box {
					height: 0.7rem;
				}
			}

			.nav_tabber_text_box:nth-child(6):hover {
				.More_options_box {
					height: 1.17rem;
				}
			}

			.nav_tabber_text_box:last-child {
				margin-right: 0rem;
			}

			.nav_tabber_text_box:hover {
				color: #ff6100;
				font-weight: 700;

				.text_box {
					.text_boxbefore {
						bottom: 0.15rem;
					}
				}
			}
		}

		.nav_tel_box {
			display: flex;

			.nav_tel_img_box {
				width: 0.1458rem;
				height: 0.1458rem;
				margin-top: 0.175rem;
				margin-left: 1.5885rem;
				background-image: url("../static/images/icon/navtel.png");
				background-size: 100% 100%;
			}

			.nav_tel_text_box {
				font-size: 0.1042rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				line-height: 0.5rem;
				color: #444444;
				opacity: 1;
				margin-left: 0.0521rem;
			}

			.nav_code_img_box {
				position: relative;
				margin-top: 0.175rem;
				margin-left: 0.2604rem;
				width: 0.1458rem;
				height: 0.1458rem;
				background-image: url("../static/images/icon/navcode.png");
				background-size: 100% 100%;
				cursor: pointer;

				.nav_code_img {
					position: absolute;
					bottom: -1.171rem;
					left: 0.62rem;
					width: 0.9844rem;
					height: 0.9844rem;
					background: #00000050;
					transition: 0.3s;
					background-image: url("../static/images/img/code.png");
					background-size: 80% 80%;
					background-position: center;
					background-repeat: no-repeat;
					opacity: 0;
				}
			}

			.nav_code_img_box:hover {
				.nav_code_img {
					left: -0.62rem;
					opacity: 1;
				}
			}
		}

		.consulting_box {
			position: relative;
			position: fixed;
			right: 0rem;
			top: 50%;
			width: 0.4167rem;
			transform: translateY(-50%);

			.consulting_li_box {
				position: relative;
				width: 0.4167rem;
				height: 0.4167rem;
				background-color: #fff;
				border-radius: 0.0208rem 0px 0px 0.0208rem;
				margin: 0.0521rem 0;
				text-align: center;
				border: 1px solid #dedede;
				cursor: default;

				i {
					display: inline-block;
					color: #666666;
					opacity: 1;
					font-size: 0.16rem;
					margin-top: 0.0833rem;
					transition: 0.3s;
				}

				span {
					display: block;
					font-size: 0.0729rem;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #666666;
					letter-spacing: 0.0104rem;
					opacity: 1;
					transition: 0.3s;
				}

				.consulting_tips_box {
					position: absolute;
					left: -0.7263rem;
					top: 0%;
					transform: translateY(-50%);
					width: 0.6563rem;
					height: 0.6563rem;
					background: #ffffff;
					background-image: url("../static/images/img/code.png");
					background-size: 95% 95%;
					background-position: center;
					background-repeat: no-repeat;
					border-radius: 0.0208rem;
					transition: 0.3s;
					opacity: 0;
					pointer-events: none;
				}

				.consulting_tips_tel_box {
					position: absolute;
					left: -0.7263rem;
					top: 0%;
					width: 0.6563rem;
					height: 0.3958rem;
					line-height: 0.3958rem;
					font-size: 0.0729rem;
					text-align: center;
					transform: translateY(-50%);
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #ff6100;
					letter-spacing: 0.0104rem;
					opacity: 0;
					transition: 0.3s;
					pointer-events: none;
					background-color: #fff;
					border-radius: 0.0208rem;
				}
			}

			.consulting_li_box:hover {
				i {
					color: #ff6100 !important;
				}

				span {
					color: #ff6100 !important;
				}

				.consulting_tips_box {
					top: 50%;
					opacity: 1;
					pointer-events: auto;
				}

				.consulting_tips_tel_box {
					top: 50%;
					opacity: 1;
					pointer-events: auto;
				}
			}
		}
	}
</style>